import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { SlotPortal } from '@mint-lib/slots';
import { useNavigate } from '@mint/admin-routing';

import { Box, Button, Icon, Typography } from '@myn/mui';

const NotFoundErrorPage = () => {
  const { t } = useTranslation('@mint-admin/secured-layout');
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      // magic number 100px is approx height of the top bar and the layout padding
      height="calc(100vh - 100px)"
      gap={(theme) => theme.spacing(8)}
    >
      <SlotPortal name="topBarTitle">{404}</SlotPortal>
      <Box
        display="inline-flex"
        flexDirection="column"
        justifyContent="center"
        gap={(theme) => theme.spacing(3)}
      >
        <Box
          display="inline-flex"
          gap={(theme) => theme.spacing(1)}
          alignItems={'center'}
        >
          <Icon component={'WarningFilled'} color={'error'} fontSize="large" />
          <Typography variant="h3" color={'error.main'}>
            {t('404 Error')}
          </Typography>
        </Box>
        <Typography variant="h1" color="text.primary" mb={2}>
          {t('Page not found')}
        </Typography>
        <Typography variant="bodyShort01" color="text.primary" mb={2}>
          {t(
            "The page you are looking for doesn't exist or you don't have permission",
          )}
        </Typography>
        <Box display="flex" gap={2}>
          <Button
            onClick={() => navigate({ to: '/' })}
            variant="contained"
            size="large"
            color="primary"
          >
            {t('Back to Start Page')}
          </Button>
        </Box>
      </Box>
      <Illustration className="size-80" component="IllustrationError404" />
    </Box>
  );
};

export default NotFoundErrorPage;
